// Vertical Mode Inactivity Timer
// Redirects to home and clears cart after 5 minutes of inactivity
(function() { 
  // Only run in vertical mode
  function isVerticalMode() {
    return document.documentElement.classList.contains('display-vertical');
  }

  if (!isVerticalMode()) {
    return;
  }

  console.log('[VerticalInactivity] Initializing inactivity timer (5 minutes)');

  const INACTIVITY_TIME = 10 * 60 * 1000; // 10 minutes in milliseconds
  let inactivityTimer = null;

  // Clear cart and redirect to home
  async function handleInactivity() {
    console.log('[VerticalInactivity] Inactivity detected - clearing cart and redirecting to home');
    
    try {
      // Clear the cart
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      console.log('[VerticalInactivity] Cart cleared successfully');
    } catch (error) {
      console.error('[VerticalInactivity] Error clearing cart:', error);
    }
    
    // Redirect to home with vertical display parameter
    window.location.href = '/?display=vertical';
  }

  // Reset the inactivity timer
  function resetTimer() {
    // Clear existing timer
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
    }
    
    // Set new timer
    inactivityTimer = setTimeout(handleInactivity, INACTIVITY_TIME);
  }

  // Debounce function to limit how often we reset the timer
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Debounced version of resetTimer (only reset once per second at most)
  const debouncedResetTimer = debounce(resetTimer, 1000);

  // Events that indicate user activity
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
    'touchmove',
    'click'
  ];

  // Add event listeners for all activity events
  activityEvents.forEach(event => {
    if (event === 'mousemove' || event === 'touchmove') {
      // Use debounced version for high-frequency events
      document.addEventListener(event, debouncedResetTimer, { passive: true });
    } else {
      document.addEventListener(event, resetTimer, { passive: true });
    }
  });

  // Start the initial timer
  resetTimer();

  console.log('[VerticalInactivity] Inactivity timer started successfully');
})();
